export default __webpack_public_path__ + "static/media/safety_grey.03c3d522.svg";